/**
 * @component RegisterModuleManage
 * @description Manages the display of authentication registration modules based on the active form state.
 * This component serves as a conditional renderer that switches between registration form components
 * depending on the current authentication flow step (initial registration or profile completion).
 *
 * @returns {JSX.Element} A fragment containing the appropriate registration form component
 * based on the active authentication module form state.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { authModulesForms } from '../../../app/store/slices/authDialog';
import VerifyEmailForm from './VerifyEmailForm';
import ProfileCompleteForm from './ProfileCompleteForm';

function RegisterModuleManage() {
    const selector = useSelector((state) => state.authDialog);

    return (
        <React.Fragment>
            {selector.activeAuthModuleForm === authModulesForms.VERIFY_EMAIL_FORM && (
                <VerifyEmailForm />
            )}
            {selector.activeAuthModuleForm === authModulesForms.COMPLETE_PROFILE_FORM && (
                <ProfileCompleteForm />
            )}
        </React.Fragment>
    );
}

export default RegisterModuleManage;
